<template>
  <v-container class="pa-0">
    <v-row class="pa-0">
      <v-col class="py-0">
        <v-select
          v-model="selectedCampus"
          label="Campus"
          :items="campuses"
          item-text="name"
          item-value="_id"
          @change="updateCampus()"
          return-object />
      </v-col>
    </v-row>
    <v-row class="pa-0">
      <v-col class="py-0">
        <v-select
          v-if="selectedCampus"
          v-model="selectedLocation"
          label="Building"
          :items="selectedLocations"
          item-text="name"
          item-value="_id"
          @change="updateLocation()"
          return-object />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import { locationSort } from '@/utils/utils'

export default {
  name: 'LocationSelector',
  watch: {
    activeLocations () {
      if (this.activeLocations.length === 1) {
        this.selectedLocation = this.activeLocations[0]._id
      } else {
        this.selectedLocation = ''
      }
    },
    activeCampus () {
      this.selectedCampus = this.activeCampus
    }
  },
  computed: {
    ...mapGetters([
      'campuses',
      'activeCampus',
      'activeLocations',
      'locations'
    ]),
    selectedLocations () {
      return this.locations
        .filter(location => {
          if (location.campus) {
            return location.campus._id === this.selectedCampus._id
          } else {
            return false
          }
        })
        .sort(locationSort)
    }
  },
  data () {
    return {
      selectedCampus: this.activeCampus,
      selectedLocation: null
    }
  },
  methods: {
    ...mapMutations([
      'setVehicle',
      'setItinerary',
      'setActiveCampus'
    ]),
    ...mapActions([
      'setActiveLocations'
    ]),
    updateCampus () {
      this.setActiveCampus(this.selectedCampus)
    },
    updateLocation () {
      this.setActiveLocations([this.selectedLocation])
    }
  }
}
</script>
